module.exports = __webpack_public_path__ + "img/news7-1.a002df14.png";